import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=8f63e61e"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"
import style0 from "./Top.vue?vue&type=style&index=0&id=8f63e61e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports